import type { IconComponent } from './icon'

export const AddCoin: IconComponent = ({ className }) => {
    return (
        <svg
            width="24"
            height="26"
            viewBox="0 0 24 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <title>Add Coin</title>
            <path
                d="M15.5 12.0713V14.5713M15.5 14.5713V17.0713M15.5 14.5713H13M15.5 14.5713H18M15.385 7.80788C14.3464 5.59984 12.1017 4.07129 9.5 4.07129C5.91015 4.07129 3 6.98144 3 10.5713C3 14.0619 5.75154 16.9099 9.204 17.0647M22 14.5713C22 18.1611 19.0899 21.0713 15.5 21.0713C11.9101 21.0713 9 18.1611 9 14.5713C9 10.9814 11.9101 8.07129 15.5 8.07129C19.0899 8.07129 22 10.9814 22 14.5713Z"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="square"
            />
        </svg>
    )
}
